import modalUtility from "./modalUtility";
import ValidationErrorService from "../services/ValidationErrorService";

export function classValidate (check, classType) {
    if (!check._model) {
        throw new Error('check is get _model property not found')
    }

    if (check._model !== classType) {
        throw new Error(`${check._model}と${classType}が一致しません`)
    }
}

export function getValidationMessage (e) {
    const status = getStatus(e)
    if(status == 422) {
        const valid = new ValidationErrorService(e)
        return valid.firstError()
    }
    return 'サーバーエラーです'
}

export function getAlertMessage (e, message) {
    const status = getStatus(e)
    if(status == 422) {
        const valid = new ValidationErrorService(e)
        if(valid.errors.message) {
            return valid.errors.message[0]
        }

        return message ? message : '入力にエラーがあります。'
    }
    return 'サーバーエラーです'
}

const getStatus = (e) => {
    if(e.response) {
        const { status } = e.response
        return status
    }
    return null
}



// WEBPACK FOOTER //
// ./resources/assets/js/utility/validateUtility.js